import React from "react";
import NoDataFound from "../../common/NoDataFound";

const sumGoals = (data, index, key) => {
  return data.reduce((sum, item) => {
    const val = item[key]?.split("-")[index];
    return sum + (val ? parseInt(val, 10) : 0);
  }, 0);
};

const GoalCell = ({ goal, keyName, type }) => {
  const val = goal[keyName];
  if (!val) return "-";
  if (type === "scored") return val.split("-")[0];
  if (type === "conceded") return val.split("-")[1];
  return val;
};

const SummaryCell = ({ data, keyName, type }) => {
  if (type === "scored") return sumGoals(data, 0, keyName);
  if (type === "conceded") return sumGoals(data, 1, keyName);
  return `${sumGoals(data, 0, keyName)}-${sumGoals(data, 1, keyName)}`;
};

const PercentageCell = ({ data, keyName, type }) => {
  const getPercent = (idx) => {
    const part = sumGoals(data, idx, keyName);
    const total = sumGoals(data, idx, "sum");
    return total > 0 ? ((part / total) * 100).toFixed(2) : "0.00";
  };

  if (type === "scored") return `${getPercent(0)}%`;
  if (type === "conceded") return `${getPercent(1)}%`;
  return `${getPercent(0)}%-${getPercent(1)}%`;
};

const timeSlots = ["q1", "q2", "q3", "q4", "q5", "q6"];

const GoalsBreakdownTable = ({ data, active, setActive }) => {
  const goals = data?.goals || [];

  return (
    <div className="league_block">
      <div className="leg_main">
        <div className="leg_head">
          <h2>Goals</h2>
        </div>
        <nav className="inner_tab">
          <ul>
            {[
              { key: "scored", label: "Goals Scored" },
              { key: "conceded", label: "Goals Conceded" },
              { key: "both", label: "Scored & Conceded" },
            ].map(({ key, label }) => (
              <li
                key={key}
                className={active === key ? "active" : ""}
                onClick={() => setActive(key)}
              >
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="global_table striped goals_tbl">
        {goals.length ? (
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Team</th>
                {timeSlots.map((slot, i) => (
                  <th key={i}>
                    {["0-15", "16-30", "31-45", "46-60", "61-75", "76-90"][i]}
                  </th>
                ))}
                <th>Sum</th>
              </tr>
            </thead>
            <tbody>
              {goals.slice(0, 20).map((goal, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{goal?.name}</td>
                  {timeSlots.map((slot) => (
                    <td key={slot}>
                      <GoalCell goal={goal} keyName={slot} type={active} />
                    </td>
                  ))}
                  <td>
                    <GoalCell goal={goal} keyName="sum" type={active} />
                  </td>
                </tr>
              ))}
              <tr>
                <td>-</td>
                <td>Sum</td>
                {timeSlots.map((slot) => (
                  <td key={slot}>
                    <SummaryCell data={goals} keyName={slot} type={active} />
                  </td>
                ))}
                <td>
                  <SummaryCell data={goals} keyName="sum" type={active} />
                </td>
              </tr>
              <tr>
                <td>-</td>
                <td>Sum%</td>
                {timeSlots.map((slot) => (
                  <td key={slot}>
                    <PercentageCell data={goals} keyName={slot} type={active} />
                  </td>
                ))}
                <td></td>
              </tr>
            </tbody>
          </table>
        ) : (
          <NoDataFound />
        )}
      </div>
    </div>
  );
};

export default GoalsBreakdownTable;
